import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { Environment } from "app/decorators/environment.decorator";
import { SnackBarService } from "app/services/snackbar.service";
import { Observable, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { ProfileService } from "../profile/profile.service";
import { ScheduleService } from "../schedule/schedule.service";
import { Unit } from "./unit";
import { PageOptions } from "../interface/pageOptions";
import { SelectProcedureComponent } from "./select-procedure/select-procedure.component";
import * as moment from "moment";

@Component({
    selector: "app-unregistered-schedule",
    templateUrl: "./unregistered-schedule.component.html",
    styleUrls: ["./unregistered-schedule.component.scss"],
})
export class UnregisteredScheduleComponent implements OnInit, OnDestroy {
    @Environment("showProfessional") showProfessional: any;
    @ViewChild("scheduleContainer") scheduleContainer!: ElementRef;
    unitControl = new FormControl("", Validators.required);
    specialityControl = new FormControl("", Validators.required);
    professionalControl = new FormControl("");
    procedureControl = new FormControl("", Validators.required);
    insuranceControl = new FormControl("", Validators.required);
    prepareProcedureControl = new FormControl("");
    observableControl = new FormControl("");

    pacienteForm: FormGroup;
    agendamentoform: FormGroup;
    loadingSchedule = false;
    unregisteredNew: Boolean = false;

    unitList = [];
    unidade = new Unit();
    specialityList = [];
    insuranceList = [];
    professionalList = [];
    professionalEspecialidade = [];
    procedureList = [];
    hourList = [];
    unityValue: any;
    filteredInsurance: Observable<string[]>;
    filteredProfessional: Observable<string[]>;
    filteredProcedure: Observable<string[]>;
    scheduleList = [];
    schedule: any;
    credential: any;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    private _unsubscribeAll: Subject<any>;

    groupedSchedules: any[];

    procedurePageOptions: PageOptions;
    insurancePageOptions: PageOptions;
    performerPageOptions: PageOptions;
    specialistyPageOptions: PageOptions;
    schedulePageOptions: PageOptions;

    scheduleIdRegister: number;

    constructor(
        private readonly scheduleService: ScheduleService,
        private _formBuilder: FormBuilder,
        private router: Router,
        private snackBar: SnackBarService,
        public _matDialog: MatDialog
    ) {
        this.procedurePageOptions = new PageOptions();
        this.performerPageOptions = new PageOptions();
        this.insurancePageOptions = new PageOptions();
        this.specialistyPageOptions = new PageOptions();
        this.schedulePageOptions = new PageOptions();

        this._unsubscribeAll = new Subject();
        this.credential = null;
        const state = this.router.getCurrentNavigation().extras.state;
        if (state && state.credential && state.credential.cpf) {
            this.credential =
                this.router.getCurrentNavigation().extras.state.credential;
        }
        let useCadComplet = JSON.parse(localStorage.getItem("enterprise"));
        if (!useCadComplet) {
        } else {
            useCadComplet.usarSemCadastro === "N"
                ? (this.unregisteredNew = true)
                : (this.unregisteredNew = false);
        }
    }
    ngOnDestroy(): void {
        if (this.scheduleIdRegister) {
            this.scheduleService.registerScheduleUsage(this.scheduleIdRegister);
        }
    }

    ngAfterViewInit() {}

    async ngOnInit() {
        localStorage.removeItem("paciente");

        ProfileService.mudarEmailAtualizado.emit(true);

        this.createForm();

        if (this.credential != null) {
            this.pacienteForm.patchValue({
                personBirthday: this.credential.dataNascimento,
                personCpf: this.credential.cpf,
            });
            const element = document.getElementById("personName");

            if (element) {
                setTimeout(() => element.focus(), 100);
            }
        } else {
            const elementCpf = document.getElementById("cpf");

            if (elementCpf) {
                setTimeout(() => elementCpf.focus(), 100);
            }
        }

        await this.getList();

        this.filterInsurance();
        this.filterSpeciality();
        this.filterProfessional();
        this.filterProcedure();
        this.initializeObservables();
    }

    initializeObservables() {
        this.procedureControl.valueChanges.subscribe((procedure) => {
            if (procedure?.preparo != null) {
                this.prepareProcedureControl.setValue(null);
                this.prepareProcedureControl.setValue(procedure.preparo);
            }
        });
    }

    save(data: any) {

        if (!this.isValidCpf(data.personCpf)) {
            this.snackBar.warnMessage("CPF inválido");
            return;
        }

        this.scheduleService
            .saveScheduleUnregistered(data)
            .then((res) => {
                this.snackBar.successMessage(
                    "Agendamento realizado com sucesso."
                );
                this.scheduleList = [];
                this.groupedSchedules = [];
                this.specialityControl.setValue(null);
                this.insuranceControl.setValue(null);
                this.unitControl.setValue(null);
                this.procedureControl.setValue(null);
                this.prepareProcedureControl.setValue(null);
                this.professionalControl.setValue(null);
                this.groupedSchedules = [];
                this.scheduleIdRegister = null;
            })
            .catch((err) => {
                console.error(err);
                if (data?.scheduleId) {
                    this.scheduleService.unregisterScheduleUsage(data.scheduleId);
                }
                this.snackBar.errorMessage(
                    err?.error?.message || "Ocorreu um erro ao salvar o agendamento."
                );
            });
    }

    handleSchedule(item: any) {
        this.scheduleIdRegister = item.id;
        this.scheduleService
            .registerScheduleUsage(item.id)
            .then((res) => {
                const dialogRef = this._matDialog.open(
                    SelectProcedureComponent,
                    {
                        width: "80%",
                        maxWidth: "95vw",
                        panelClass: "clearPadding",
                        autoFocus: false,
                        data: {
                            insuranceId: this.insuranceControl?.value?.id,
                            performerId: item.performerId,
                            companyId: this.unitControl?.value?.id,
                        },
                    }
                );

                dialogRef.afterClosed().subscribe((result) => {
                    console.log(`Dialog result: ${result}`);
                    if (!result?.id) {
                        this.scheduleService.unregisterScheduleUsage(item.id);
                        this.scheduleIdRegister = null;
                        return;
                    }

                    let data = this.pacienteForm.getRawValue();
                    data.procedureId = result.id;
                    data.companyId = this.unitControl.value.id;
                    data.insuranceId = this.insuranceControl.value.id;
                    data.scheduleId = item.id;
                    data.personBirthday = moment(
                        data.personBirthday,
                        "DD/MM/YYYY"
                    ).format("YYYY-MM-DD");
                    console.log("Dados do paciente:", data);

                    this.confirmDialogRef = this._matDialog.open(
                        FuseConfirmDialogComponent,
                        {
                            disableClose: false,
                        }
                    );
                    this.confirmDialogRef.componentInstance.confirmMessage =
                        "Deseja confirmar o agendamento?";
                    this.confirmDialogRef.componentInstance.confirmTitle =
                        "Confirmação";
                    this.confirmDialogRef.afterClosed().subscribe((confirmed) => {
                        if (confirmed) {
                            this.save(data);
                        } else {
                            this.scheduleService.unregisterScheduleUsage(item.id);
                            this.scheduleIdRegister = null;
                        }
                        this.confirmDialogRef = null;
                    });
                });
            })
            .catch((err) => {
                return;
            });
    }

    async createForm() {
        this.pacienteForm = this._formBuilder.group({
            personName: ["", Validators.required],
            personCpf: ["", Validators.required],
            personBirthday: ["", Validators.required],
            personTel: [""],
            personPhone: ["", Validators.required],
            obs: [""],
            procedureId: [""],
            companyId: [""],
            insuranceId: [""],
            scheduleId: [""],
        });

        this.agendamentoform = this._formBuilder.group({
            idAgenda: ["", Validators.required],
            idunidade: ["", Validators.required],
            idProfissional: ["", Validators.required],
            idProcedimento: ["", Validators.required],
            dataAgenda: ["", Validators.required],
            horaAgenda: ["", Validators.required],
        });
    }

    async getList() {
        await this.scheduleService.getUnityList().then((res: any) => {
            this.unitList = res;
        });

        this.getInsuranceList();
        this.getSpecialityList();
    }

    getProcedureList() {
        const insuranceId = this.insuranceControl?.value?.id;
        const performerId = this.professionalControl?.value?.performerId;
        const companyId = this.unitControl?.value?.id;

        if (insuranceId && performerId && companyId) {
            this.scheduleService
                .getProcedurePageSimpleList(
                    this.procedurePageOptions,
                    insuranceId,
                    performerId,
                    companyId
                )
                .then((res) => {
                    this.procedureList = res.body.content;
                })
                .catch((err) =>
                    console.error("Erro ao buscar procedimentos:", err)
                );
        } else {
            this.procedureList = [];
        }
    }

    filterProcedure() {
        this.procedureControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && res.name) {
                    this.procedurePageOptions.argument = res.name;
                }
                if (typeof res === "string") {
                    filter = res;
                }
                this.procedurePageOptions.argument = filter;
                this.getProcedureList();
            });
    }

    getProfessionalList() {
        const specialityId = this.specialityControl.value?.id;
        const companyId = this.unitControl.value?.id;
        const insuranceId = this.insuranceControl.value?.id;

        if (!specialityId || !companyId || !insuranceId) {
            this.professionalList = [];
            return;
        }

        this.scheduleService
            .getPerformerAllPageNoEntity(
                this.performerPageOptions,
                specialityId,
                companyId,
                insuranceId
            )
            .then((res) => {
                this.professionalList = res.body.content;
            });
    }

    filterProfessional() {
        this.professionalControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && res.performerName) {
                    this.performerPageOptions.argument = res.performerName;
                }
                if (typeof res === "string") {
                    filter = res;
                }
                this.performerPageOptions.argument = filter;
                this.getProfessionalList();
            });
    }

    getInsuranceList() {
        this.scheduleService
            .getInsurancePageSimpleList(this.insurancePageOptions)
            .then((res) => {
                this.insuranceList = res.body.content;
            });
    }

    getScheduleeList(qtd?: number) {
        if (!this.checkFields() || this.loadingSchedule) return;
        this.loadingSchedule = true;
        this.scrollToSchedules();

        if (qtd) {
            this.schedulePageOptions.sizePage =
                this.schedulePageOptions.sizePage + qtd;
        }

        this.scheduleService
            .getSchedulePageSimpleList(
                this.schedulePageOptions,
                this.professionalControl.value?.performerId,
                this.unitControl.value?.id,
                this.specialityControl.value?.id,
                this.insuranceControl.value?.id
            )
            .then((res) => {
                this.scheduleList = res.body.content || [];
                if (this.scheduleList.length <= 0) {
                    this.scheduleList = [];
                    this.groupedSchedules = [];
                    this.snackBar.warnMessage(
                        "Nenhum horário disponível para os filtros selecionados."
                    );
                    return;
                }
                this.groupSchedulesByDate();
            })
            .finally(() => {
                this.loadingSchedule = false; // encerra o loading, sucesso ou erro
                this.scrollToSchedules();
            });
    }

    private groupSchedulesByDate(): void {
        const groupedByDate: Record<string, any> = {};

        this.scheduleList.forEach((item) => {
            if (!groupedByDate[item.date]) {
                groupedByDate[item.date] = {};
            }

            if (!groupedByDate[item.date][item.performerId]) {
                groupedByDate[item.date][item.performerId] = {
                    performerId: item.performerId,
                    performerName: item.performerName,
                    specialityName: item.specialityName,
                    hours: [],
                };
            }

            groupedByDate[item.date][item.performerId].hours.push(item);
        });

        this.groupedSchedules = Object.keys(groupedByDate).map((date) => ({
            date,
            performers: Object.values(groupedByDate[date]),
        }));

    }

    private scrollToSchedules(): void {
        [0, 100, 300].forEach((delay) => {
            setTimeout(() => {
                window.requestAnimationFrame(() => this.forceScheduleScroll());
            }, delay);
        });
    }

    private forceScheduleScroll(): void {
        const target = this.scheduleContainer?.nativeElement as HTMLElement;
        if (!target) return;

        target.scrollIntoView({ block: "start", inline: "nearest" });

        let parent = target.parentElement;
        let internalScrollApplied = false;
        while (parent) {
            const overflowY = window.getComputedStyle(parent).overflowY;
            const canScroll = /auto|scroll|hidden|overlay/.test(overflowY);

            if (canScroll && parent.scrollHeight > parent.clientHeight) {
                const targetRect = target.getBoundingClientRect();
                const parentRect = parent.getBoundingClientRect();
                const top =
                    parent.scrollTop + targetRect.top - parentRect.top - 12;

                parent.scrollTop = Math.max(0, top);
                internalScrollApplied = true;
            }

            parent = parent.parentElement;
        }

        if (!internalScrollApplied) {
            const top =
                target.getBoundingClientRect().top + window.pageYOffset - 12;
            window.scrollTo(0, Math.max(0, top));
        }
    }

    filterInsurance() {
        this.insuranceControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && res.name) {
                    this.insurancePageOptions.argument = res.name;
                }
                if (typeof res === "string") {
                    filter = res;
                }
                this.insurancePageOptions.argument = filter;
                this.getInsuranceList();
            });
    }

    getSpecialityList() {
        this.scheduleService
            .getSpecialistyPageSimpleList(this.specialistyPageOptions)
            .then((res) => {
                this.specialityList = res.body.content;
            });
    }

    filterSpeciality() {
        this.specialityControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && res.name) {
                    this.specialistyPageOptions.argument = res.name;
                }
                if (typeof res === "string") {
                    filter = res;
                }
                this.specialistyPageOptions.argument = filter;
                this.getSpecialityList();
            });
    }

    displayFn(speciality?: any): string | undefined {
        if (!speciality) {
            return null;
        }
        if (typeof speciality === "string") {
            return speciality;
        }
        return speciality.name;
    }

    checkFieldsPerson(): boolean {
        let valid = true;
        if (!this.pacienteForm.controls.personName.valid) {
            this.snackBar.warnMessage("O campo nome deve está preenchido.");
            this.pacienteForm.controls.personName.markAsTouched();
            valid = false;
        } else if (!this.pacienteForm.controls.personBirthday.valid) {
            this.snackBar.warnMessage(
                "Data de nascimento deve está preenchido."
            );
            this.pacienteForm.controls.personBirthday.markAsTouched();
            valid = false;
        } else if (
            !this.pacienteForm.controls.personCpf.valid ||
            !this.pacienteForm.controls.personPhone.valid ||
            !this.pacienteForm.controls.personBirthday.valid ||
            !this.specialityControl.valid ||
            !this.insuranceControl.valid
        ) {
            this.snackBar.warnMessage("Verifique os campos em destaque.");
            this.pacienteForm.controls.personCpf.markAsTouched();
            this.pacienteForm.controls.personName.markAsTouched();
            this.pacienteForm.controls.personPhone.markAsTouched();
            this.pacienteForm.controls.personBirthday.markAsTouched();
            this.specialityControl.markAsTouched();
            this.insuranceControl.markAsTouched();
            valid = false;
        } else if (!this.unitControl.value?.id) {
            this.snackBar.warnMessage("Campo unidade é obrigatório.");
            valid = false;
        } else if (!this.insuranceControl.value?.id) {
            this.snackBar.warnMessage("Campo convênio é obrigatório.");
            this.insuranceControl.markAsTouched();
            valid = false;
        } else if (!this.procedureControl.value?.id) {
            this.snackBar.warnMessage("Campo procedimento é obrigatório.");
            this.procedureControl.markAsTouched();
            valid = false;
        }
        return valid;
    }

    checkFields() {
        let valid = true;
        if (!this.pacienteForm.controls.personName.valid) {
            this.snackBar.warnMessage("O campo nome deve está preenchido.");
            this.pacienteForm.controls.personName.markAsTouched();
            valid = false;
        } else if (!this.pacienteForm.controls.personBirthday.valid) {
            this.snackBar.warnMessage(
                "Data de nascimento deve está preenchido."
            );
            this.pacienteForm.controls.personBirthday.markAsTouched();
            valid = false;
        } else if (
            !this.pacienteForm.controls.personCpf.valid ||
            !this.pacienteForm.controls.personPhone.valid ||
            !this.pacienteForm.controls.personBirthday.valid ||
            !this.specialityControl.valid ||
            !this.insuranceControl.valid
        ) {
            this.snackBar.warnMessage("Verifique os campos em destaque.");
            this.pacienteForm.controls.personCpf.markAsTouched();
            this.pacienteForm.controls.personName.markAsTouched();
            this.pacienteForm.controls.personPhone.markAsTouched();
            this.pacienteForm.controls.personBirthday.markAsTouched();
            this.specialityControl.markAsTouched();
            this.insuranceControl.markAsTouched();
            valid = false;
        } else if (!this.unitControl.value?.id) {
            this.snackBar.warnMessage("Campo unidade é obrigatório.");
            valid = false;
        } else if (!this.insuranceControl.value?.id) {
            this.snackBar.warnMessage("Campo convênio é obrigatório.");
            this.insuranceControl.markAsTouched();
            valid = false;
        } else if (!this.specialityControl.value?.id) {
            this.snackBar.warnMessage("Campo especialidade é obrigatório.");
            this.specialityControl.markAsTouched();
            valid = false;
        }
        return valid;
    }

    displayFnProfessional(obj?: any): string {
        if (obj) {
            if (typeof obj === "string") {
                return obj;
            }
            if (!obj.performerName) {
                return null;
            }
            return obj.performerName;
        }
        return null;
    }

    validateCpf(): void {
        const cpf = this.pacienteForm
            .get("personCpf")
            ?.value?.replace(/\D/g, ""); // remove pontos e traço

        if (!cpf) return;

        if (!this.isValidCpf(cpf)) {
            this.snackBar.warnMessage("CPF inválido");
            this.pacienteForm.get("personCpf")?.setErrors({ invalidCpf: true });
        } else {
            this.pacienteForm.get("personCpf")?.setErrors(null);
        }
    }

    /** Função para validar CPF */
    private isValidCpf(cpf: string): boolean {
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;

        return resto === parseInt(cpf.charAt(10));
    }
}
